import { createFileRoute } from '@tanstack/react-router'

import VerificationWilkerPenyuluhPage from '@/components/pages/backoffice/_verification-wilker-penyuluh/containers/VerificationWilkerPenyuluhPage'

export const Route = createFileRoute(
  '/_backoffice/verification-wilker-penyuluh/'
)({
  component: VerificationWilkerPenyuluhPage
})
